export type AppReloadGuard = () => Promise<boolean>;

let activeGuard: AppReloadGuard | null = null;

/**
 * Registers the one currently mounted editor that may need to flush local
 * state before the application reloads. The initial app has a single reader
 * screen, so a small registry is sufficient and avoids coupling PWA controls
 * to reader component state.
 */
export function registerAppReloadGuard(guard: AppReloadGuard): () => void {
  activeGuard = guard;
  return () => {
    if (activeGuard === guard) activeGuard = null;
  };
}

export async function prepareForAppReload(): Promise<boolean> {
  return activeGuard ? activeGuard() : true;
}
